import { produce } from "immer";
import { TablesState } from "../interfaces/tables-state";


export const editTableHandler = function (state: TablesState, tableId: string, editRow: boolean) {

  if (editRow == undefined) {
    return state;
  }

  const nextState = produce(state[tableId], draft => {
    draft.editRow = editRow;
  })

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}

export const tableRowIndexHandler = function (state: TablesState, tableId: string, index: number | null) {
  const nextState = produce(state[tableId], draft => {
    draft.index = index;
  })

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}

export const editSaveTableHandler = function (state: TablesState, tableId: string, index: number, editRow: boolean, save: boolean) {
  if (index == undefined)
    return state;
  if (index < 0)
    save = false;

  const nextState = produce(state[tableId], draft => {
    draft.index = index;
    draft.editRow = editRow;
    draft.save = save;
  });

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}

export const updateRowHandler = function (state: TablesState, tableId: string, save: boolean) {



  const nextState = produce(state[tableId], draft => {

    draft.save = save;
  });

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}
export const finishedUpdateRowHandler = function (state: TablesState, tableId: string) {


  const nextState = produce(state[tableId], draft => {
    draft.editRow = false;
    draft.save = false;
  });

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}